import styled from "styled-components"

export const StyledSwitch = styled.div<{ $fullWidth?: boolean }>`
  display: flex;
  ${({ $fullWidth }) => $fullWidth && "width: 100%;"}
`

export const FlexInner = styled.div<{ $fullWidth?: boolean }>`
  display: flex;
  flex-grow: ${({ $fullWidth }) => ($fullWidth ? 1 : 0)};
  background: rgba(255, 255, 255, 0.05);
  border-radius: 100px;
  position: relative;
`

export const SwitchOption = styled.div<{
  $isActive: boolean
  $disabled: boolean
  $fullWidth?: boolean
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  padding: 10px 16px;
  font-size: 12px;
  font-weight: 700;
  line-height: 12px;
  letter-spacing: 0.12px;
  z-index: 1;
  flex-shrink: 0;
  white-space: nowrap;
  cursor: ${(props) => (props.$disabled ? "not-allowed" : "pointer")};
  opacity: ${(props) => (props.$disabled ? 0.5 : 1)};
  color: #fff;
  ${({ $fullWidth }) => $fullWidth && "flex: 1;"}
`

export const ActiveMask = styled.div<{
  $width: number
  $left: number
  $hasTransition: boolean
}>`
  background: var(--neutral-white-default-20, rgba(255, 255, 255, 0.2));
  border-radius: 100px;
  height: 100%;
  top: 0;
  position: absolute;
  width: ${({ $width }) => $width}px;
  left: ${({ $left }) => $left}px;
  z-index: 0;
  border: 0.75px solid rgba(0, 38, 58, 0.14);
  transition: ${({ $hasTransition }) =>
    $hasTransition ? "width 0.2s ease, left 0.2s ease" : "none"};
`
